import actions from './actions';

const { enableScrolling, disableScrolling } = actions;

export default {
  enableScrolling,
  disableScrolling
};
